import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import DatePicker from "components/common/DatePicker";

@autobind
/**
 *
 */
export default class Date extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    return <DatePicker />;
  }
}
